import React from "react";

import "./SelectOption.scss";
import placeholder from "src/images/placeholder-universal.svg";
import { Img } from "../Img/Img";

interface Props {
  name: string;
  imageSource?: string;
  fallbackImageSource?: string;
}

export default function SelectOption({
  name,
  imageSource,
  fallbackImageSource,
}: Props) {
  return (
    <span className="select-option">
      {imageSource && (
        <Img
          loading="lazy"
          className="select-option__image select-option__image--square"
          src={imageSource}
          fallbackImageSrc={fallbackImageSource || placeholder}
          alt="avatar"
        />
      )}
      <span className="select-option__text">{name}</span>
    </span>
  );
}
